import { render, staticRenderFns } from "./diseaseLable.vue?vue&type=template&id=0035cf8e&scoped=true"
import script from "./diseaseLable.vue?vue&type=script&lang=js"
export * from "./diseaseLable.vue?vue&type=script&lang=js"
import style0 from "./diseaseLable.vue?vue&type=style&index=0&id=0035cf8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035cf8e",
  null
  
)

export default component.exports